import { axios as request } from "../../request/http";

const interfaceUrl = {
//   "api_shopInfoAdd": `/shop/spInfo/add`, // post 添加资金商&服务商管理
//   "api_shopInfoQuery": "/shop/spInfo/query", // get 查询资金商&服务商管理
//   "api_shopInfoQueryAll": "/shop/spInfo/queryAll", // get 查询资金商&服务商管理
  "api_productSpuList": "/product/spu/queryList", //查询SPU
//   "api_shopInfoUpdate": "/shop/spInfo/update" // post 更新资金商&服务商管理
}

// initial state
const state = {
  productSpuList: [],
}

// getters
const getters = {
  getProductSpuList: state => {
    return state.productSpuList
  },
}

// actions
const actions = {
    getProductSpuList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSpuList,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOPINFO_QUERY_LIST', res || {});
      } else {
        commit('SHOPINFO_QUERY_LIST', {});
      }
    }).catch(err => {
      commit('SHOPINFO_QUERY_LIST', {});
    })
  },
}


// mutations
const mutations = {
  SHOPINFO_QUERY_LIST: (state, pageData) => {
    state.productSpuList = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/productSpu.js